/*
 * Purpose : Approval page for L1 and L2 approvals
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{useState,useEffect} from 'react'
import ReactTable from "react-table";
import numeral from 'numeral'
import _ from 'lodash'
import {  Col,  Row,  Button, FormGroup,  Label,  Input, Alert, FormText} from "reactstrap";
import { l1ApprovalTableHeaders, l2ApprovalTableHeaders, approvalStages } from '../../../config/constants';
import RSInput from "../../UI/CustInput/RSInput/RSInput";
import './Approval.css'
import moment from 'moment';

const L1L2Approval = (props) => {
    console.log("data=>",props)
    const [processing, setProcessing] = useState(false)
    const [confirmError, setConfirmError] = useState(null)
    const [showAlert, setShowAlert] = useState(true)
    const [data, setData] = useState(props.data)
    const [headerData, setHeaderData] = useState(props.headerData)
    const [fileData, setFileData] = useState({})
    const [columns, setColumns] = useState([])

    // to get index value of a particular tool id
    const getIndex = (id) => {
      console.log("toolRecord.id=>", id);
      let newRecord = [...data]
      console.log("newRecord=>",newRecord)
      const index = _.findIndex(newRecord, (o) => {
      console.log("o.id=>", o.id);      
      return o.id === id;
        });
      
      return index;

    }
    
    // to handle NBV changes
    const onNBVChangeHandler = async (e,rowObj)=>{
        
        console.log(e.target.value)
        console.log(rowObj.row._original)
        console.log("pecent",numeral(e.target.value).format('0.00%'))

      //   const caret = event.target.selectionStart
      // const element = event.target
      // window.requestAnimationFrame(() => {
      //   element.selectionStart = caret
      //   element.selectionEnd = caret
      // })
        
      
        // let newRecord = [...data]
        // console.log("newRecord=>",newRecord)
        // const index = _.findIndex(newRecord, (o) => {
        //   console.log("o.id=>", o.id);
        //   console.log("toolRecord.id=>", rowObj.row._original.id);
        //   return o.id === rowObj.row._original.id;
        // });
        let newRecord = [...data]
        const index = getIndex(rowObj.row._original.id);
        console.log('index=>',index)
        //let updatedNBV = e.target.value && parseFloat(e.target.value).toFixed(2)
        newRecord[index]["nbv"] = ( e.target.value && Number(e.target.value).toString() ) || 0
        //newRecord[index]["price_percent"] = e.target.value
        console.log("newRecord=>",newRecord)
        setData(newRecord)
    }

    // to handle original price changes
    const onOriginalCostChange = async (e,rowObj)=>{        
      console.log(e.target.value)
      console.log(rowObj.row._original)
      let newRecord = [...data]
      const index = getIndex(rowObj.row._original.id);
        console.log('index=>',index)
        //let updatedNBV = e.target.value && parseFloat(e.target.value).toFixed(2)
        newRecord[index]["org_eqp_price"] = ( e.target.value && Number(e.target.value).toString() ) || 0
        newRecord[index]["price_percent"] = e.target.value != 0 ? ((newRecord[index]["price"]/e.target.value)*100).toString() : newRecord[index]["price_percent"].toString()
        console.log("newRecord=>",newRecord)
        setData(newRecord)
    }
    // to handle date changes
    const onDateChange = async (e,rowObj)=>{        
      console.log(e.target.value)
      console.log(rowObj.row._original)
      let newRecord = [...data]
      const index = getIndex(rowObj.row._original.id);
      console.log("index=>",index)
      newRecord[index]["capitalized_date"] = e.target.value || newRecord[index]["capitalized_date"]
      setData(newRecord)
    }
    // to handle finance analysis changes
    const onFinAnalysisChange = async (e,rowObj)=>{        
      console.log("in onFinAnalysisChange")
      console.log(e.target.value)
      console.log(rowObj.row._original)
      let newRecord = [...data]
      const index = getIndex(rowObj.row._original.id);
      console.log("index=>",index)
      newRecord[index]["fin_analysis"] = e.target.value
      setData(newRecord)
    }
    // to handle check box changes
    const handleCheckBox = async (e,rowObj)=>{
        console.log("check box=>",e.target.checked)
        console.log(e.target.value)
        console.log(rowObj.row._original)
        let newRecord = [...data]
        const index = getIndex(rowObj.row._original.id);
        console.log("index=>",index)
        newRecord[index]["no_internal_reuse"] = e.target.checked ? "Yes":"No";
        console.log("newRecord=>",newRecord)
        setData(newRecord)
    }
    // to handle text input changes
    const inputChangeHandler = async (event) => {
      console.log("event.target.value=>", event.target.value);
      console.log("event.target.name=>", event.target.name);  
      setFileData({
        ...fileData,
        [event.target.name]: event.target.value,
      })
    };
    // to handle file changes
    const fileChangeHandler = (event) =>{
      console.log("event==>",event.target.files[0])
  
      
      const url = window.URL.createObjectURL(event.target.files[0])
  
      setFileData({
        ...fileData,
        mimetype:event.target.files[0].type,
        name:event.target.files[0].name,  
        [event.target.name]: event.target.files[0], //sets file object to file
        url: url,
      })
      
      // const byteArray = new Uint8Array(event.target.files[0])
      // const blob = new Blob([event.target.files[0]], { type: event.target.files[0].type })
      // const url = window.URL.createObjectURL(blob)
      
      //const url = window.URL.createObjectURL(event.target.files[0])
  
      // setHeaderData({
      //   ...headerData,
      //   [event.target.name]: event.target.files[0],
      //   fileName: event.target.files[0].name,
      //   url: url,
      // });
      
    }

    const submitApproval = () => {
      
      //checking nbv value for multiple tools in declared list
      if(headerData.status === approvalStages.l1Approval){
        let grouped = _.mapValues(_.groupBy(data, 'toolid'),
        toolList => toolList.map(tool => tool.nbv ));
        let nbvErrorList = Object.entries(grouped).map(list => {
        return (list[1].filter(x => x > 0).length > 1)?`${list[0]} is having more than one row with NBV value greater than zero.`:null
        }).filter(finalListElement=>finalListElement)
        console.log("nbvErrorList=>",nbvErrorList)
        if(nbvErrorList.length>0){
          setConfirmError(nbvErrorList.map( msg=> <p>{msg}<br/></p> ))
          return
        }
        let originalPriceList = data.map( element => element.org_eqp_price)
        console.log("originamPriceList=>",originalPriceList)                
        if(originalPriceList.some(element => element <= 0)){
          setConfirmError("One or more Original Eqpt Cost fields are having zero value. Original Eqpt Cost cannot be zero")
          return
        }
        let finAnalysisList = data.map( element => element.fin_analysis.length)
        console.log("finAnalysisList=>",finAnalysisList)
        if(finAnalysisList.some(element => element <= 0)){
          setConfirmError("One or more Finance Analysis fields are having empty value.")
          return
        }
        
      }else{
        let no_internal_reuse = data.map( element => element.no_internal_reuse)
        console.log("no_internal_reuse=>",no_internal_reuse)
        if(no_internal_reuse.some(element => element === "No")){
          setConfirmError("You have one/more unchecked checkbox. Please validate and confirm")
          return
        }        
      }
      

      props.submitHandler(data, headerData, fileData)
    }

    useEffect(() => {
        
        const buildData = async () => {
            // set Table Headers
            const columns = [];

            console.log("Checking headerdata=>",headerData)

            let tableHeaders = (headerData.status === approvalStages.l1Approval)?l1ApprovalTableHeaders:l2ApprovalTableHeaders            
            
            Object.keys(tableHeaders).forEach((col, i) => {
              if( col === "toolid" ) {
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 120,
                  headerClassName: 'header-style',
                  className:'column-style'
                  //headerClassName: 'wordwrap'
                });
              }else if( col === "location" || col === "vendor" ) {
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 130,
                  headerClassName: 'header-style',
                  className:'column-style'
                  //headerClassName: 'wordwrap'
                });
              }
              else if(col === "price"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 120,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
                 }
                    
                });
              }
              else if(col === "nbv"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 150,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"center"}}>
                                <Input
                                    type="number" className="appr-column-style-right" bsSize="sm"
                                    onChange={(event)=>onNBVChangeHandler(event,e)} value={e.value} 
                                />
                                {/* <input className="appr-column-style-right" type="number" size="8" onChange={(event)=>onNBVChangeHandler(event,e)} value={e.value} /> */}
                            </div>
                 }
                    
                });
              }else if(col === "org_eqp_price"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 160,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"center"}}>
                              <Input
                                  type="number" className="appr-column-style-right" bsSize="sm"
                                  onChange={(event)=>onOriginalCostChange(event,e)} value={e.value} 
                              />
                                {/* <input className="appr-column-style-right" type="number" size="8" onChange={(event)=>onNBVChangeHandler(event,e)} value={e.value} /> */}
                            </div>
                 }
                    
                });
              }else if(col === "price_percent"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 215,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"center"}}>
                                <Input
                                  type="text" className="appr-column-style-right" bsSize="sm" readOnly
                                  value={numeral(e.value/100).format('0.00%')} 
                                />
                            </div>
                 }
                    
                });
              }else if(col === "capitalized_date"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 160,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"center"}}>
                                <Input
                                    bsSize="sm"
                                    type="date"
                                    name="date"
                                    id="exampleDate"
                                    placeholder="date placeholder"
                                    onChange={(event)=>onDateChange(event,e)} value={e.value?e.value:moment().format("YYYY-MM-DD")} 
                                  />
                            </div>
                 }
                    
                });
              }else if(col === "fin_analysis"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 250,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"center"}}>
                                <Input
                                    type="textarea" bsSize="sm" onChange={(event)=>onFinAnalysisChange(event,e)} value={e.value} 
                                />
                            </div>
                 }
                    
                });
              }else if(col === "no_internal_reuse"){
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 300,
                  headerClassName: 'header-style',
                  className:'column-style',
                  //headerClassName: 'wordwrap'
                  Cell: e=> {              
                      return <div style={{textAlign:"center"}}>
                                <Input
                                    checked={e.value==="Yes"? true : false}
                                    type="checkbox"
                                    //bsSize="md" 
                                    onChange={(event)=>handleCheckBox(event,e)} value={e.value} 
                                    style={{height: "15px",width: "15px", position:"relative"}}
                                />
                            </div>
                 }
                    
                });
              }
              else if( col === "remarks" ) {
                columns.push({
                  Header:tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 250,            
                  headerClassName: 'header-style',
                  getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            whiteSpace:"unset",
                            fontSize: rowInfo?.row?.[col]?.length > 70 ? "x-small" : "smaller"
                        },
                      };
                  },
      
                });
              }
              else if(col === "asset_mgt_status") {
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  minWidth: 160,
                  headerClassName: 'header-style',
                  className:'column-style'
                });
              }
              else {
                columns.push({
                  Header: tableHeaders[col],
                  accessor: col,
                  filterable: false,
                  headerClassName: 'header-style',
                  className:'column-style'
                  //headerClassName: 'wordwrap'
                });
              }
            });
            setColumns(columns);            
          };
          
        buildData();
        console.log("called")
    },[])

    useEffect(() => {
      let toolList = [...data]
      console.table("toolList==>",toolList)
      let temp_total_price=0;
      let temp_total_nbv=0;
      let temp_total_gain_loss=0;
      toolList.forEach( toolObj => {
        let nbv = numeral(toolObj.nbv).value()
        temp_total_price = numeral(temp_total_price).add(toolObj.price).value()
        temp_total_nbv = numeral(temp_total_nbv).add(nbv).value()
      })
      console.log("temp_total_price=>",temp_total_price)  
      console.log('numeral(temp_total_price)=>',numeral(temp_total_price).format('0,0.00'))
      console.log("temp_total_nbv=>",temp_total_nbv)  

      temp_total_gain_loss = numeral( numeral(temp_total_price).subtract(temp_total_nbv) ).value();
      console.log("total_gain_loss==>",temp_total_gain_loss)

      setHeaderData({
        ...headerData,
        total_price:temp_total_price,
        total_nbv:temp_total_nbv,
        total_gain_loss:temp_total_gain_loss
      })

    }, [data])
    
    return (
        <div>
            <Alert color="danger" isOpen={confirmError != null ? true : false} toggle={()=> setConfirmError(null)}>
              {confirmError}
            </Alert>
            <Alert color="info" isOpen={showAlert} toggle={()=>setShowAlert(prev=>!prev)}>
              {(headerData.status === approvalStages.l1Approval)
                ? "Please review/edit the details for all tools"
                : "Please confirm validation has been done for each tool on reuse and trade in opportunity"
              }
            </Alert>
            <ReactTable
                data={data}
                columns={columns}
                defaultPageSize={data.length}
                className="-striped -highlight"
                showPagination={false}
              />
              <div
                style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%", display:(headerData.status === approvalStages.l1Approval) ? "block" : "none" } }
                
              >
                <Row
                  form
                  style={{ justifyContent: "flex-start", marginTop: "30px" }}
                >
                  <Col md="4">                
                    <RSInput name="total_price" id="total_price"
                        value={"$ "+numeral(headerData.total_price).format('0,0.00')}
                        readOnly
                        required={true}
                        labelText="Total Price($US)"
                    />
                  </Col>
                  <Col md="4">
                    <RSInput name="total_nbv" id="total_nbv"
                        value={"$ "+numeral(headerData.total_nbv).format('0,0.00')}
                        readOnly
                        required={true}
                        labelText="Total NBV($US)"
                    />
                  </Col>
                  <Col md="4">                
                    <RSInput name="total_gain_loss" id="total_gain_loss"
                        value={"$ "+numeral(headerData.total_gain_loss).format('0,0.00')}
                        readOnly
                        required={true}
                        labelText="Total Gain/Loss($US)"
                    />
                  </Col>
                </Row>
              </div>
              <div
                style={{ textAlign: "left", marginTop:"5%", marginLeft: "2%", marginRight: "2%", 
                        display:(headerData.status === approvalStages.l2Approval) ? "block" : "none" } }
              >
                <Row form style={{ justifyContent: "space-evenly" }}>
                  <Col md={5}>
                    <FormGroup>
                      <Row form style={{ justifyContent: "space-evenly" }}>
                        <Col md="auto">
                          <Label for="description">SUTL Checklist</Label>
                        </Col>
                        <Col md="auto">
                          <Input
                            type="text"
                            name="description"
                            id="description"
                            placeholder="Enter file description..."
                            onChange={(e) => inputChangeHandler(e)}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                <Col md="5">
                  <FormGroup>
                    <Input type="file" name="file" id="file"
                      onChange={(e) => fileChangeHandler(e)}
                      accept=".xlsx, .xls, .doc, .docx, .pdf, image/*"
                    />
                    <FormText color="muted">accepts pdf,word,excel,jpg,png</FormText>
                  </FormGroup>

                  {/* <div
                    className={"file-wrap-sales"}
                    style={{ display: ( fileData.url && fileData.file?.type?.indexOf("image/")===-1 ) ? "inline-block" : "none" }}
                  >
                    <a
                      key={fileData.name}
                      href={fileData.url}
                      download={fileData.name}
                    >
                      {" "}
                      {
                        fileData.url && (fileData?.name?.indexOf("-$") !== -1 
                        ? 
                          fileData?.name?.replace(fileData.name?.substr(fileData.name?.indexOf("-$"),10),"") 
                        : 
                          fileData.name
                        )
                      }{" "}
                    </a>
                    <MdClose className={"close"} onClick={resetFileData} />
                  </div> */}
                  {/* <div className={"img-wrap-sales"} style={{ display: ( fileData.url && fileData.file?.type?.indexOf("image/")!==-1 ) ? "inline-block" : "none" }} >
                  {" "}
                      {
                        fileData.url && (fileData?.name?.indexOf("-$") !== -1 
                        ? 
                          fileData?.name?.replace(fileData.name?.substr(fileData.name?.indexOf("-$"),10),"") 
                        : 
                          fileData.name
                        )
                      }{" "}
                      <MdClose className={"close"} onClick={resetFileData} />
                    <img src={fileData.url} alt="problem in loading tool" width="100%" height="100%" />                        
                  </div> */}
                </Col>
              </Row>
            </div>

              <FormGroup style={{textAlign: "center", marginTop:"1rem"}}>
                <Row>
                    <Col>
                    <Button color="primary" className={"userFormBtn"} style={{backgroundColor:"#fb8734"}}
                            disabled={processing} onClick={()=>submitApproval(data,"L1 Submit")}>
                            { processing && <span><i className="fa fa-spinner fa-spin"></i>  Processing... </span> }
                            { !processing && <span>Submit</span> }
                    </Button>
                    </Col>
                    <Col>
                    <Button color="secondary" className={"userFormBtn"} value="" onClick={props.closeHandler}>Close</Button>
                    </Col>
                </Row>
            </FormGroup>
        </div>
    )
}

export default L1L2Approval
